import { GetServerSideProps } from "next";
import Link from "next/link";

import styles from "../../styles/dimensions/Dimensions.module.css";
import ProfileHeader from "@/components/publicProfiles/Header/ProfileHeader";
import BreadCrumbs from "@/components/shared/breadCrumbs/BreadCrumbs";
import dimensionsData from "../../assets/traitInfo/dimensions.json";
import { Dimension } from "@dimensional-engineering/dimensional-models";
import DimensionRectangle from "@/components/shared/dimensions/DimensionRectangle";
import { usePublicProfileContext } from "@/context/PublicProfileContext";
import MobileSearchPage from "@/components/publicProfiles/Header/MobileSearchPage";
import Footers from "@/components/shared/Footers/Footers";
import TraitsSEOHeader from "@/components/traits/shared/TraitsSEOHeader";
import LargeTraitsHeading from "@/components/traits/shared/LargeTraitsHeading/LargeTraitsHeading";

type DimensionsHomeProps = {
  dimensionsData: Dimension[];
};

export default function DimensionsHome(props: DimensionsHomeProps) {
  const { mobileSearchOpen } = usePublicProfileContext();
  return (
    <>
      <TraitsSEOHeader
        title={`Dimensional || Dimensions`}
        description="The Dimensional personality test consists of “Dimensions” that explore our Personality through
            different contexts and frameworks."
      />
      {mobileSearchOpen === true && <MobileSearchPage />}
      <ProfileHeader />
      <div className={styles.main}>
        <div className={styles.top}>
          <BreadCrumbs list={["Dimensions"]} urls={[]} />
          <LargeTraitsHeading title="All Dimensions" />
          <p className={styles.subHeading}>
            The Dimensional
            <span>
              <Link href={"https://about.dimensional.me/personality-test"}>
                Personality Test{" "}
              </Link>
            </span>
            consists of “Dimensions” that explore our Personality through
            different contexts and frameworks.
          </p>
        </div>
        <div className={styles.parent}>
          {props.dimensionsData.map((dim, index) => {
            return <DimensionRectangle {...dim} key={index} />;
          })}
        </div>
      </div>
      <Footers />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const data = dimensionsData;
  return {
    props: {
      dimensionsData: data,
    },
  };
};
